import React from 'react';
import Page from '../../lib/page';
import { Menu } from 'antd';
import { Icon } from '../../component';
import env from '../../lib/env';
import styles from './index.css';

const Intro = () => (
	<div className={styles.content}>
		<div className={styles.title}>关于长歌中文网</div>
		<div className={styles.title2}>欢迎来到长歌中文网！</div>
		<div style={{ padding: '10px 0' }}>
			这是一家致力于挖掘优秀网文作者、努力培养潜力新人作者的新兴原创文学网站！<br />
			我们用心浇筑梦想，用行动夯实道路，用创作改变人生，长歌中文网将努力为提高优秀作者收入，给更多新人作者赋予创作机会。
		</div>
	</div>
);

const Contact = () => (
	<div className={styles.content}>
		<div className={styles.title}>联系我们</div>
		<div style={{ paddingTop: '30px', overflow: 'hidden' }}>
			<div>责编 可可 QQ： 3761963638</div>
		</div>
	</div>
)

export default class AboutPage extends Page {

	get_content() {
		let loc = 'intro';
		if (this.props.location.hash) {
			loc = this.props.location.hash.substr(1);
		}
		let content = null;
		switch (loc) {
			case 'intro':
				content = <Intro />
				break;
			case 'contact':
				content = <Contact />
				break;
			default:
				content = <div />
		}
		return { loc, content };
	}

	render() {
		const { loc, content } = this.get_content();
		return (
			<div style={{ width: '1000px', height: "500px", margin: '0 auto' }}>
				<div style={{
					width: '200px',
					float: 'left',
				}}>
					<Menu selectedKeys={[loc]} style={{ borderRight: 'none' }}>
						<Menu.Item key="intro" className={styles.icon}
							onClick={() => env.goto_page('/about#intro')}>
							{/* <Icon.Wandu />关于长歌 */}
							关于长歌
						</Menu.Item>
						<Menu.Item key="contact" className={styles.icon}
							onClick={() => env.goto_page('/about#contact')}>
							{/* <Icon.CustomerSrv />联系我们 */}
							联系我们
						</Menu.Item>
					</Menu>
				</div>
				<div style={{
					marginLeft: '230px',
					minHeight: '250px',
				}}>
					{content}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/layout/about/index.js